"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SIANewsletterTop = _interopRequireDefault(require("./SIANewsletterTop/SIANewsletterTop"));
var _Events = _interopRequireDefault(require("./Events/Events"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-organisation-newsletter {\n  display: flex;\n  max-width: 672px;\n  flex-direction: column;\n  margin: auto; }\n  .sia-organisation-newsletter .bottom {\n    justify-content: center;\n    padding-left: 16px;\n    padding-right: 16px; }\n    .sia-organisation-newsletter .bottom .left-container {\n      width: 100%;\n      max-width: 455px; }\n    .sia-organisation-newsletter .bottom .right-container {\n      width: 100%;\n      max-width: 293px; }\n  .sia-organisation-newsletter svg {\n    overflow: initial; }\n  .sia-organisation-newsletter .picture-container {\n    padding-bottom: 24px; }\n  .sia-organisation-newsletter .downloadlinkbox-container {\n    padding-right: 0px; }\n    .sia-organisation-newsletter .downloadlinkbox-container p {\n      width: auto; }\n\n@media (max-width: 42rem) {\n  .sia-organisation-newsletter {\n    max-width: 640px; } }\n";
  const fileName = "SIAOrganisationNewsletter_SIAOrganisationNewsletter";
  const element = document.querySelector("style[data-sass-component='SIAOrganisationNewsletter_SIAOrganisationNewsletter']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAOrganisationNewsletter = _ref => {
  let {
    item,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-organisation-newsletter"
  }, /*#__PURE__*/_react.default.createElement(_SIANewsletterTop.default, {
    item: item
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom"
  }, /*#__PURE__*/_react.default.createElement(_Events.default, {
    items: item.organisation_events_list,
    lang: lang,
    event_labels: item.sia_newsletter_labels,
    agenda_url: item.agenda_url
  }), /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    items: item.newsletter_body,
    lang: lang,
    translate: translate
  })));
};
var _default = exports.default = SIAOrganisationNewsletter;